import { render, staticRenderFns } from "./FrozenBills.vue?vue&type=template&id=1323ba11&scoped=true"
import script from "./FrozenBills.vue?vue&type=script&lang=js"
export * from "./FrozenBills.vue?vue&type=script&lang=js"
import style0 from "./FrozenBills.vue?vue&type=style&index=0&id=1323ba11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1323ba11",
  null
  
)

export default component.exports